export const GET_SITEMAP_PENDING = 'GET_SITEMAP_PENDING';
export const GET_SITEMAP_SUCCESS = 'GET_SITEMAP_SUCCESS';
export const GET_SITEMAP_FAILURE = 'GET_SITEMAP_FAILURE';
